let AiChat = {
    init: function () {
        this.bind();
    },

    bind: function () {
        this.form();
    },

    form: function () {
        let _this = this;

        let aiChatForm = $('.ai-chat-form');
        let submitBtn = Ladda.create(aiChatForm.find('[type=submit]')[0]);
        let chatContainer = $('#chat');

        aiChatForm.ajaxForm({
            beforeSubmit: function () {
                submitBtn.start();
            },
            success: function (response) {
                submitBtn.stop();
                if (response.success) {
                    let tracksHtml = '';

                    if (response.data.tracks && response.data.tracks.length > 0 && false) {
                        tracksHtml += '<div class="tracks">' +
                            '   <label>Related Media</label>';

                        response.data.tracks.forEach(track => {
                            tracksHtml += `<div>
                          <a href="${track.media_url}" target="_blank">
                             ${track.title} (Segment: ${track.start_time} - ${track.end_time})
                          </a>
                       </div>`;
                        });

                        tracksHtml += '</div>';
                    }

                    let responseHtml = `
                        <div class="author">
                            <div class="name">${response.data.author}</div>
                            <div class="message">${response.data.message}</div>
                        </div>
                        <div class="ai">
                            <div class="name">Josh Phegan AI</div>
                            <div class="message">
                                ${response.data.response}
                                ${tracksHtml}
                            </div>
                        </div>
                    `;

                    chatContainer.prepend(responseHtml);
                    aiChatForm.find('[name=message]').val('');
                } else {
                    toastr.error(response.message);
                }
            },
            error: function () {
                submitBtn.stop();
            }
        });
    },
};

$().ready(function () {
    window.AiChat = AiChat;
    window.AiChat.init();
});